import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'pxc-gradient',
  standalone: true,
  templateUrl: './gradient.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'aspect-4/1',
  },
})
export class GradientComponent {}
